export const SET_SAFE_BOXES = 'SET_SAFE_BOXES';
export const CREATE_SAFE_BOX = 'CREATE_SAFE_BOX';
export const UPDATE_SAFE_BOX = 'UPDATE_SAFE_BOX';
export const SET_SAFE_BOX = 'SET_SAFE_BOX';
export const FREEZE_SAFEBOX = 'FREEZE_SAFEBOX';
export const UNFREEZE_SAFEBOX = 'UNFREEZE_SAFEBOX';
export const SET_PAGINATION = 'SET_PAGINATION';
